import './App.css';

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { getToken } from './Utils/Common';
import Auth from './Components/App/Auth';
import Page443 from './Components/Pages/Page443';
import Page404 from './Components/Pages/Page404';
import Tickets from './Components/Tickets/Tickets';
import Schedules from './Components/Schedules/Schedules';
import SchedulesDetails from './Components/Schedules/SchedulesDetails';
import AgentFloats from './Components/AgentFloats/AgentFloats';
import AgentCardFloats from './Components/AgentCardFloats/AgentCardFloats';
import TicketsDetails from './Components/Tickets/TicketsDetails';

function App() {

  function PrivateRoute({ children }) {
    const auth = getToken();
    return auth ? children : <Navigate to="/443" />;
  }

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='*' element={< Page404 />}></Route>
          <Route exact path='/' element={< Page404 />}></Route>
          <Route exact path='/404' element={< Page404 />}></Route>
          <Route exact path='/443' element={< Page443 />}></Route>
          <Route exact path="/auth/:token/:page" element={<Auth />} />
          <Route exact path="/full-tickets" element={<PrivateRoute> <Tickets /></PrivateRoute>} />
          <Route exact path="/full-schedules" element={<PrivateRoute> <Schedules /></PrivateRoute>} />
          <Route exact path="/full-schedules/:id" element={<PrivateRoute> <SchedulesDetails /></PrivateRoute>} />
          <Route exact path="/full-agent-floats" element={<PrivateRoute> <AgentFloats /></PrivateRoute>} />
          <Route exact path="/full-agent-card-floats" element={<PrivateRoute> <AgentCardFloats /></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
